'use memo'

import React from 'react'
import { EnvironmentOutlined } from '@ant-design/icons'
import { ScrollSpyLayout } from 'src/components/ScrollSpyLayout'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { TextField, CountryProvinceField, FieldRow } from '../FormikField'

const AddressSection: React.FC = () => (
  <ScrollSpyLayout.Section
    id='address'
    title={capitalizeWords('Address')}
    icon={<EnvironmentOutlined />}
  >
    <FieldRow cols={1}>
      <TextField
        name='addressStreet1'
        label='Address Line 1'
        placeholder={capitalizeWords('Street address')}
      />
    </FieldRow>
    <FieldRow cols={1}>
      <TextField
        name='addressStreet2'
        label='Address Line 2'
        placeholder={capitalizeWords('Apt, suite, unit, etc.')}
      />
    </FieldRow>
    <FieldRow>
      <TextField
        name='addressCity'
        label='City'
        placeholder={capitalizeWords('City')}
      />
      <TextField
        name='addressPostalCode'
        label='Postal Code'
        placeholder={capitalizeWords('Postal/ZIP code')}
      />
    </FieldRow>
    <FieldRow cols={1}>
      <CountryProvinceField
        countryName='addressCountryId'
        provinceName='addressProvinceId'
      />
    </FieldRow>
  </ScrollSpyLayout.Section>
)

export default AddressSection
